import request from '@/utils/request'

export async function getData(params) {
  return request({
    // url: '/statistics/car_application_state/statistics',
    url: '/v3/statistics/car_application_state/statistics',
    method: 'get',
    params,
  })
}
export async function exportReport(params) {
  return request({
    // url: '/statistics/car_application_state/export',
    url: '/v3/statistics/car_application_state/export',
    method: 'get',
    params,
  })
}
